"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.tooltips.talk': 'Rozpocznij rozmowę z tym awatarem',
    'avatar.tooltips.preview': 'Podgląd szczegółów awatara',
    'avatar.tooltips.edit': 'Edytuj ustawienia awatara',
    'avatar.tooltips.delete': 'Usuń tego awatara',
};
